module.exports = __webpack_public_path__ + "img/02.241b25e0.png";